import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/FreightQuotation/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            <span>Freight Quotation</span>{' '}
            <span>Forms and Templates</span>
          </h1>
          <p className={cn('header__heading-description')}>
            The sale doesn't happen when the cargo moves; it happens when the quote is signed. A freight
            quotation is your first impression. It’s the formal offer of services that outlines exactly what
            you will do and what it will cost. For forwarders, a messy email quote can lose a deal, but a
            clear, professional quotation template builds trust and prevents the dreaded "hidden fee"
            arguments later on.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;